import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureHomepageCarouselHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configureHomepageCarouselHttp must be called before use')
  return http
}

export const listHomepageCarouselItems = () => client().get('/homepage-carousel', { routeId: 'visualGame.homepageCarousel.list' })
export const createHomepageCarouselItem = body => client().post('/homepage-carousel', { body, routeId: 'visualGame.homepageCarousel.create' })
export const updateHomepageCarouselItem = (id, body) => client().put(`/homepage-carousel/${encodeURIComponent(id)}`, { body, routeId: 'visualGame.homepageCarousel.update' })
export const deleteHomepageCarouselItem = id => client().delete(`/homepage-carousel/${encodeURIComponent(id)}`, { routeId: 'visualGame.homepageCarousel.delete' })
export const reorderHomepageCarouselItems = ids => client().put('/homepage-carousel/reorder', { body: { ids }, routeId: 'visualGame.homepageCarousel.reorder' })
